import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// RemixIcon font — the sidebar renders module icons straight from the DB
// catalog (icon strings like 'ri-dashboard-line'), so the font must load.
import 'remixicon/fonts/remixicon.css';
// Sentry must init before any component renders so it can catch
// their errors. File auto no-ops when VITE_SENTRY_DSN isn't set.
import './lib/sentry';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
